import React from 'react';

export const Contacts: React.FC<React.HTMLAttributes<SVGElement>> = (props) => (
  <svg viewBox="0 0 16 16" {...props}>
    <path
      d="M12.1 13.595L9.422 11.81a.276.276 0 00-.369.06l-.78 1a.836.836 0 01-1.071.221l-.144-.079a9.419 9.419 0 01-2.458-1.92 9.407 9.407 0 01-1.917-2.449l-.079-.144a.836.836 0 01.221-1.071l1-.78a.276.276 0 00.06-.369L2.1 3.597a.274.274 0 00-.369-.083l-1.12.672a1.078 1.078 0 00-.493.636C-.25 6.162.06 8.509 3.623 12.073s5.91 3.874 7.251 3.506a1.078 1.078 0 00.636-.494l.672-1.12a.274.274 0 00-.082-.37z"
      fill="currentColor"
    />
    <path
      d="M15.836.707a.154.154 0 00-.111-.045H3.841a.154.154 0 00-.156.156v4.131l.674 1.013a.845.845 0 01-.184 1.132l-1 .78a.271.271 0 00-.073.347l.082.149a7.153 7.153 0 00.947 1.38h11.6a.155.155 0 00.156-.153V.818a.154.154 0 00-.051-.111zm-8.061 5.16L4.868 8.981a.284.284 0 11-.415-.387L7.36 5.481a.284.284 0 11.415.387zm2.006-.224a.94.94 0 01-.567-.187l-4.742-3.6a.284.284 0 11.344-.452l4.74 3.6a.383.383 0 00.45 0l4.742-3.6a.284.284 0 11.343.452l-4.742 3.6a.94.94 0 01-.564.187zm5.332 3.35a.284.284 0 01-.4-.014L11.81 5.862a.284.284 0 01.416-.386l2.906 3.113a.284.284 0 01-.015.404z"
      fill="currentColor"
    />
  </svg>
);
